<template>
  <VView class="quiz-game" back-button-to="/menu" :header="header">
    <VGame @end="onGameEnd($event)" @levelChange="levelIndex = $event" />
  </VView>
</template>

<script>
import VGame from '@/games/vue-quiz/VGame.vue';
import { SET_ATTACHMENT, SET_SCORE } from '@/store';

export default {
  name: 'QuizGame',

  components: {
    VGame,
  },

  data: () => ({
    levelIndex: 0,
  }),

  computed: {
    header() {
      return `Pytanie ${this.levelIndex + 1}`;
    },
  },

  methods: {
    onGameEnd({ attachment, score }) {
      this.$router.push(`/quiz/end?score=${score}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-game {}
</style>
